// React
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'
import { compose } from 'redux'

// Components
import Errors from './Errors'
import Totals from './Totals'
import Services from 'store/components/Services'
import { CartPickerButton } from 'store/modules/cart/CartPicker/Button'
import ReadOnlyModeDisabledComponent from 'store/components/ReadOnlyModeDisabledComponent'

// Shared
import clientActions from 'store/v2/redux/actions/client'
import { withTranslation } from 'shared/utils/withTranslation'

export class EmbeddableCartSidebar extends Component {
  static displayName = 'EmbeddableCartSidebar'

  static propTypes = {
    cart: PropTypes.object,
    checkoutButtonValid: PropTypes.bool,
    checkingOut: PropTypes.bool,
    setCheckingOut: PropTypes.func,
    usePrices: PropTypes.bool,
    showContinueShopping: PropTypes.bool,
    showDatePicker: PropTypes.bool,
    t: PropTypes.func
  }

  static defaultProps = {
    showContinueShopping: true,
    showDatePicker: true
  }

  handleBack = (event) => {
    window.history.back()
    event?.preventDefault()
  }

  render () {
    const {
      cart,
      checkoutButtonValid,
      showDatePicker,
      checkingOut,
      setCheckingOut,
      usePrices,
      showContinueShopping,
      t
    } = this.props
    const checkoutButtonClass = checkoutButtonValid ? 'bq-enabled' : 'bq-disabled'

    return (
      <div className="bq-cart-sidebar">
        {showDatePicker && <CartPickerButton />}
        <div className="booqable-component" style={{ display: 'none' }}>
          <Services cart={cart} />
          {usePrices && cart && cart.lines.length > 0 && (
            <Fragment>
              <hr />
              <Totals cart={cart} />
            </Fragment>
          )}
          <hr />
          <Errors />
          {checkingOut && (
            <div className="bq-loading-wrapper">
              <div className="bq-loader" />
            </div>
          )}
          {!checkingOut && (
            <ReadOnlyModeDisabledComponent>
              <button
                onClick={setCheckingOut}
                className={`bq-checkout-button bq-branded bq-button ${checkoutButtonClass}`}
              >
                {t('user.store.checkout')}
              </button>
            </ReadOnlyModeDisabledComponent>
          )}
          {showContinueShopping && (
            <button onClick={this.handleBack} className="bq-checkout-button bq-back-button bq-button">
              {t('user.store.continue_shopping')}
            </button>
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  const cart = state.orm.carts.getById(state.client.cartId)

  let cannotCheckout

  const hasDates = !!(cart?.starts_at && cart?.stops_at)
  const useAvailability = state.settings.get('store.use_availability')
  const usePrices = state.settings.get('store.use_prices')

  // Check if we need to calculate if use can checkout
  if (useAvailability) {
    cannotCheckout =
      state.orm.lines
        .getAll({
          id: cart?.lines,
          can_checkout: false
        })
        .size() > 0
  } else {
    cannotCheckout = false
  }

  const checkoutButtonValid = !!(
    (Number(cart?.lines?.length || 0) > 0) &&
    hasDates &&
    !cannotCheckout &&
    !state.client.cartOverdue
  )

  return {
    cart,
    checkingOut: state.client.checkingOut,
    checkoutButtonValid,
    usePrices,
    showContinueShopping: props.continueShopping,
    showDatePicker: props.datepicker
  }
}

const mapDispatchToProps = (_dispatch, _props) => {
  return {
    setCheckingOut: (e) => {
      e.preventDefault()

      if (clientActions.evaluateCartOverdue()) return

      clientActions.setCheckingOut()
    }
  }
}

export default compose(
  reduxConnect(mapStateToProps, mapDispatchToProps),
  withTranslation('user')
)(EmbeddableCartSidebar)
